// react
import React, { useState, useEffect } from 'react'


// Appt
import Box from '../../simple/box/Box'
import Text from '../../simple/text/Text'

import ConnectionService from '../../../services/ConnectionService'

/**
 * `ConnectionCheck` makes a regular check
 * to see if the connection is still available
 * displaying a banner if not
 */
function ConnectionCheck (props) {
  const [connected, setConnected] = useState(true)

  useEffect(() => {
    const interval = setInterval(async () => {
        const connection = await ConnectionService.getConnection()

        if (connection?.status === 'forbidden') {
          // token is invalid - we need to log the user out
          window.location.replace('/logout')
          return
        }

        setConnected(connection?.status === 'ok')
    }, 10000)
    return () => clearInterval(interval)
  }, [])

  return (
    <>
      {!connected && (
        <Box background='besmartOrange' height="xxsmall" direction='row' gap='small' margin={{ bottom: 'medium' }} round='small' justify='between' align='center'>
          <Box direction='column' pad={{ horizontal: 'medium', vertical: 'small' }}>
            <Text color='besmartBlue' weight='bold'>ERROR - There is a problem connecting to the server. Please wait, the system will automatically reconnect</Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default ConnectionCheck
